var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('canvas',{attrs:{"id":this.id,"width":"100","height":"40"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }